import React from 'react';
import { InputItem } from 'antd-mobile';

class Remark extends React.Component{
    render(){
        let {api_name, is_required, form, is_readonly} = this.props;
        const {getFieldProps, getFieldError} = form;
        
        let tempProps = {
            name: api_name,
            placeholder: $st('请输入单选备注')
        };
        let fieldProps = getFieldProps(api_name, {
            initialValue: '',
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`paas.smart.form.isrequired`)
                }, {
                    pattern: /[^\s]+/,
                    message: '不能为空',
                }]
            }]
        });
        let errorText = getFieldError(api_name);

        return (
            <div className="remark-wrap">
                <InputItem {...tempProps} {...fieldProps} disabled={is_readonly}/>
                {errorText && <div className='input-error remark-input-error'>{errorText}</div>}
            </div>
        )
    }
}
export default Remark;


// WEBPACK FOOTER //
// ./src/form/select/remark.js